import { INGESTION_CONSTANTS } from './Ingestion.constants';

export const getIsIngestRunning = (ingestStatus: number | undefined) =>
  ingestStatus === INGESTION_CONSTANTS.RUNNING;
export const getIsIngestStopping = (ingestStatus: number | undefined) =>
  ingestStatus === INGESTION_CONSTANTS.TRIGGERED_STOP;
